import { VariaveisAmbiente } from "ambiente";
import { useApiBase } from "api/base";
import { MovRegistrarModel } from "api/cardapio/models/mov-pag/mov-registrar";
import { useCallback } from "react";

export function usePostMovRegistrar() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const postMovRegistrar = useCallback(
        (data: MovRegistrarModel, empresaId: string) => {
            return invocarApi({
                url: `api/v4/empresa/${empresaId}/pagamento/registrar`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    'Domain': 'app.touchone.com.br',
                },
                data: data,
                enviarTokenUsuario: false,
                baseURL: VariaveisAmbiente.masterApi,
            });
        },
        [invocarApi]
    );

    return {
        ...outrasPropriedades,
        postMovRegistrar,
    };
}